// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__adKUG","shouldBeResponsive":"Layout_shouldBeResponsive__9oZ3D","content":"Layout_content__FqjNh"};